import { useState } from 'react'
import { DndContext, DragEndEvent } from '@dnd-kit/core'
import { restrictToWindowEdges } from '@dnd-kit/modifiers'
import { isEqual, sortBy } from 'lodash'

import LootHistorySingleResponseType from './LootHistorySingleResponseType'
import EntityDroppable from 'app/frontend/base/components/EntityDroppable'
import { useFormContext } from 'react-hook-form'
import { FormValues } from './LootHistoryResponseTypeModal'

const LootHistoryResponseTypes = () => {
  const [dragging, setDragging] = useState(false)
  const { watch, setValue } = useFormContext<FormValues>()
  const values = watch()

  const handleDragEnd = (event: DragEndEvent) => {
    const newTypeOrder = [...values.loot_history_response_type_order]

    if (event.over?.id) {
      const movedType = newTypeOrder.indexOf(Number(event.active.id))
      const movedTo = newTypeOrder.indexOf(
        parseInt(String(event.over.id).split('-')[1]),
      )

      if (movedTo !== movedType) {
        newTypeOrder.splice(movedType, 1)
        newTypeOrder.splice(
          movedTo +
            (movedType < movedTo ? -1 : 0) +
            (String(event.over.id).split('-')[0] == 'before' ? 0 : 1),
          0,
          Number(event.active.id),
        )

        if (!isEqual(newTypeOrder, values.loot_history_response_type_order)) {
          setValue('loot_history_response_type_order', newTypeOrder)
        }
      }
    }

    setDragging(false)
  }

  const handleDragStart = () => {
    setDragging(true)
  }

  const topLevelTypes = values.loot_history_response_types_attributes.filter(
    (type) => !type.synonym_of_id,
  )

  return (
    <div className={`relative flex flex-col gap-1`}>
      <DndContext
        onDragEnd={handleDragEnd}
        onDragStart={handleDragStart}
        modifiers={[restrictToWindowEdges]}
      >
        {sortBy(
          values.loot_history_response_types_attributes.filter(
            (t) => !t.excluded,
          ),
          (type) => values.loot_history_response_type_order.indexOf(type.id),
        ).map((responseType) => (
          <div key={responseType.id} className='relative'>
            <EntityDroppable
              orientation='before'
              id={responseType.id}
              className={dragging ? '' : 'pointer-events-none'}
            />

            <LootHistorySingleResponseType
              dragging={dragging}
              responseType={responseType}
              typeOptions={topLevelTypes}
            />

            <EntityDroppable orientation='after' id={responseType.id} />
          </div>
        ))}
      </DndContext>
    </div>
  )
}

export default LootHistoryResponseTypes
